module.exports = {
  translation: {
    "total": "Total",
    "round": "Round",
    "country": "Country",
    "noScoresFound": "No scores found for this tournament.",
    "position": "Rank",
    "thru": "Thru",
    "eagle": "Eagle or better",
    "birdie": "Birdie",
    "par": "Par",
    "single": "Single",
    "team": "Team",
    "bogey": "Bogey",
    "doublebogey": "Double Bogey",
    "triplebogey": "Triple Bogey or worse",

    // Errors
 }
}